const separator = "...";

export function trim(text: string, length = 11) {
	if (text.length <= length) {
		return text;
	}

	const toShow = (length - separator.length) / 2;
	const start = text.slice(0, toShow);
	const end = text.slice(-toShow);
	return `${start}${separator}${end}`;
}
